'use client';
import { TheBoatAppLandingConfigType, useConfig } from '@marine/configs';
import { FC } from 'react';
import { SanityImage } from 'sanity-image';
import styles from './SimilarPostCard.module.scss';

type SimilarPostCardImageProps = {
  imageId: string;
  altText: string;
};

const SimilarPostCardImage: FC<SimilarPostCardImageProps> = ({ imageId, altText }) => {
  const { projectId, dataset } = useConfig<TheBoatAppLandingConfigType>();

  return (
    <SanityImage
      id={imageId}
      projectId={projectId}
      dataset={dataset}
      width={400}
      height={300}
      alt={altText}
      className={styles.image}
    />
  );
};

export { SimilarPostCardImage };
